module.exports = __webpack_public_path__ + "static/media/pin.3fd678e5.svg";